// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xt9J","label":"styles_label__2k79V"};